import { createAsyncAction, createAction } from "typesafe-actions";
import { PaginatedResponse, SensorDataRestoringRequestFilter, WithCallback } from "@shared/interfaces";
import { SensorDataRestoringRequest } from "@shared/models/SensorDataRestoringRequest";

import { SensorDataRestoringRequestActionTypes } from "./constants";
import {
  CreateSensorDataRestoringRequestRequest,
  CreateSensorDataRestoringRequestResponse,
  DeleteSensorDataRestoringRequestRequest,
  DeleteSensorDataRestoringRequestResponse,
  GetSensorDataRestoringRequestRequest,
  DownloadSensorDataRestoringRequestRequest,
  DownloadSensorDataRestoringRequestResponse,
  RestoreSensorDataRestoringRequestRequest,
  RestoreSensorDataRestoringRequestResponse,
} from "../interfaces";

export const getSensorDataRestoringRequests = createAsyncAction(
  SensorDataRestoringRequestActionTypes.GET_SENSOR_DATA_RESTORING_REQUESTS,
  SensorDataRestoringRequestActionTypes.GET_SENSOR_DATA_RESTORING_REQUESTS_SUCCESS,
  SensorDataRestoringRequestActionTypes.GET_SENSOR_DATA_RESTORING_REQUESTS_FAILURE,
)<SensorDataRestoringRequestFilter, PaginatedResponse<SensorDataRestoringRequest>, Error>();

export const getSensorDataRestoringRequest = createAsyncAction(
  SensorDataRestoringRequestActionTypes.GET_SENSOR_DATA_RESTORING_REQUEST,
  SensorDataRestoringRequestActionTypes.GET_SENSOR_DATA_RESTORING_REQUEST_SUCCESS,
  SensorDataRestoringRequestActionTypes.GET_SENSOR_DATA_RESTORING_REQUEST_FAILURE,
)<GetSensorDataRestoringRequestRequest, SensorDataRestoringRequest | null, Error>();

export const downloadSensorDataRestoringRequest = createAsyncAction(
  SensorDataRestoringRequestActionTypes.DOWNLOAD_SENSOR_DATA_RESTORING_REQUEST,
  SensorDataRestoringRequestActionTypes.DOWNLOAD_SENSOR_DATA_RESTORING_REQUEST_SUCCESS,
  SensorDataRestoringRequestActionTypes.DOWNLOAD_SENSOR_DATA_RESTORING_REQUEST_FAILURE,
)<DownloadSensorDataRestoringRequestRequest, DownloadSensorDataRestoringRequestResponse, Error>();

export const restoreSensorDataRestoringRequest = createAsyncAction(
  SensorDataRestoringRequestActionTypes.RESTORE_SENSOR_DATA_RESTORING_REQUEST,
  SensorDataRestoringRequestActionTypes.RESTORE_SENSOR_DATA_RESTORING_REQUEST_SUCCESS,
  SensorDataRestoringRequestActionTypes.RESTORE_SENSOR_DATA_RESTORING_REQUEST_FAILURE,
)<WithCallback<RestoreSensorDataRestoringRequestRequest>, RestoreSensorDataRestoringRequestResponse, Error>();

export const deleteSensorDataRestoringRequest = createAsyncAction(
  SensorDataRestoringRequestActionTypes.DELETE_SENSOR_DATA_RESTORING_REQUEST,
  SensorDataRestoringRequestActionTypes.DELETE_SENSOR_DATA_RESTORING_REQUEST_SUCCESS,
  SensorDataRestoringRequestActionTypes.DELETE_SENSOR_DATA_RESTORING_REQUEST_FAILURE,
)<DeleteSensorDataRestoringRequestRequest, DeleteSensorDataRestoringRequestResponse, Error>();

export const createSensorDataRestoringRequest = createAsyncAction(
  SensorDataRestoringRequestActionTypes.CREATE_SENSOR_DATA_RESTORING_REQUEST,
  SensorDataRestoringRequestActionTypes.CREATE_SENSOR_DATA_RESTORING_REQUEST_SUCCESS,
  SensorDataRestoringRequestActionTypes.CREATE_SENSOR_DATA_RESTORING_REQUEST_FAILURE,
)<WithCallback<CreateSensorDataRestoringRequestRequest>, CreateSensorDataRestoringRequestResponse, Error>();

export const setFilter = createAction(
  SensorDataRestoringRequestActionTypes.SET_FILTER,
)<SensorDataRestoringRequestFilter | null>();
